__turbopack_context__.v({
  "active": "video-player-component-module-scss-module__CuAa3q__active",
  "progress-bar": "video-player-component-module-scss-module__CuAa3q__progress-bar",
  "progress-bar-padding": "video-player-component-module-scss-module__CuAa3q__progress-bar-padding",
  "progress-timer": "video-player-component-module-scss-module__CuAa3q__progress-timer",
  "video-buttons": "video-player-component-module-scss-module__CuAa3q__video-buttons",
  "video-controls": "video-player-component-module-scss-module__CuAa3q__video-controls",
  "video-player": "video-player-component-module-scss-module__CuAa3q__video-player",
  "video-player__play-button": "video-player-component-module-scss-module__CuAa3q__video-player__play-button",
  "volume-slider": "video-player-component-module-scss-module__CuAa3q__volume-slider",
  "volume-widget": "video-player-component-module-scss-module__CuAa3q__volume-widget",
});
